import type { SurfaceHostedIn } from '@hibro/shared';
import { type ReactNode } from 'react';

import { SurfaceHostedInContext } from './surface-hosted-in-context';

/** Marks a window root as the workbench or a detached window (见 8). */
export function SurfaceHostedInProvider({
  value,
  children,
}: {
  value: SurfaceHostedIn;
  children: ReactNode;
}): ReactNode {
  return (
    <SurfaceHostedInContext.Provider value={value}>
      {children}
    </SurfaceHostedInContext.Provider>
  );
}
